module.exports = __webpack_public_path__ + "img/cluster-36-advert.9793fde8.svg";